import { i18n } from '@fs/zion-locale'

export default {
  completed: () => i18n.t('cameraProjectStatus.completed', 'Completed'),
  currentStatusAriaLabel: () => i18n.t('cameraProjectStatus.currentStatusAriaLabel', 'Current status'),
  notStarted: () => i18n.t('cameraProjectStatus.notStarted', 'Not Started'),
  production: () => i18n.t('cameraProjectStatus.inProduction', 'In Production'),
  overallStatus: () => i18n.t('cameraProjectStatus.overallStatus', 'Overall Status'),
}
